import styled from 'styled-components';

const PageTitle = styled.h1`
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export default PageTitle;